import React from 'react';
import BottomNav from '../components/BottomNav';

const DesignerJewellery = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Designer Jewellery</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Exquisite Fine Jewellery</p>
        
        <div className="card">
          <p>
            Discover exceptional designer jewellery from the world's premier houses. 
            Access exclusive collections and bespoke creation services.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Luxury Brands</h3>
              <p>Cartier, Tiffany, Bvlgari, and more</p>
            </div>
            <div className="feature-item">
              <h3>Bespoke Creation</h3>
              <p>Custom designs crafted by master jewellers</p>
            </div>
            <div className="feature-item">
              <h3>Investment Pieces</h3>
              <p>Rare and valuable jewellery with appreciation potential</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default DesignerJewellery;
